export const environment = {
    production: true,
    api_domain: 'http://192.168.6.118',
    reconnectInterval: 5000,
};
